export default {
  init() {
    const lottieElements = document.querySelectorAll('lottie-player');

    if (lottieElements.length > 0) {
      import('@lottiefiles/lottie-player')
        .then(() => {
          console.log('Lottie player is succesvol dynamisch ingeladen!');
        })
        .catch(error => {
          console.error('Fout bij het laden van de Lottie player:', error);
        });
    }
  },
  finalize() {
  },
};
